export {
  StadiumSharedConfigWrapper,
  StadiumSharedGlobalConfigContext,
} from "@stadium/hooks/lib/use-stadium-shared-global-config";
